import { HomeLessMsPromo } from './HomeLessMsPromo'
import promptfreePoster from '@/assets/moss-orb-terrarium-poster.avif'

const promptfreeUrl = 'https://promptfr.ee'
const promptfreeVideoUrl = 'https://assets.gosha.ee/bgs/moss-orb-terrarium_web.mp4'

export const HomePromptfreePromo = () => {
  return (
    <section aria-labelledby="home-projects-heading" className="mx-auto w-full max-w-[448px] px-4">
      <h2
        id="home-projects-heading"
        className="mb-4 flex h-6 items-center font-['Familjen_Grotesk'] text-[20px] font-normal leading-6 tracking-[-0.2px] text-black"
      >
        Projects
      </h2>

      <div className="relative min-h-[133px] overflow-hidden rounded-[16px] bg-black px-4 py-3 text-white">
        <div className="pointer-events-none absolute top-0 left-[240px] h-full w-[239px] overflow-hidden">
          <img
            src={promptfreePoster}
            alt=""
            width={239}
            height={134}
            className="h-full w-full max-w-none scale-[1.35] object-cover md:hidden"
            decoding="async"
          />
          <video
            className="hidden h-full w-full max-w-none scale-[1.35] object-cover md:block"
            src={promptfreeVideoUrl}
            poster={promptfreePoster}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-hidden="true"
          />
          <div className="absolute inset-y-0 left-0 w-[131px] bg-gradient-to-r from-black to-transparent" />
        </div>

        <div className="relative z-10 flex max-w-[314px] flex-col items-start gap-[18px]">
          <p className="font-['Familjen_Grotesk'] text-[22px] font-normal leading-[23.76px] tracking-[-0.44px] text-white">
            Promptfr.ee &mdash; oneshot AI prompts for stunning websites
          </p>

          <a
            href={promptfreeUrl}
            rel="noreferrer"
            target="_blank"
            className="inline-flex items-center justify-center rounded-[8px] bg-white px-4 py-2.5 text-center text-[15px] font-medium leading-[22.5px] tracking-[-0.15px] text-black transition-[background-color,transform] duration-150 [transition-timing-function:cubic-bezier(0.2,0,0,1)] hover:bg-white/92 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black"
            aria-label="Explore Promptfr.ee (opens in new tab)"
          >
            Explore
          </a>
        </div>
      </div>
      <HomeLessMsPromo />
    </section>
  )
}
